import { formatCurrency } from '@fourthwall/utils/dist/currency'
import isNaN from 'lodash-es/isNaN'
import type { ChangeEvent, FocusEvent, KeyboardEvent } from 'react'
import React from 'react'
import { withFormikSupport } from '../../hocs/withFormikSupport'
import { Input } from '../Input'
import { BLOCKED_NUMBER_CHARACTERS, MAXIMUM_AMOUNT } from './constants'
import type { Props } from './types'
import { validateValue } from './utils'

const CurrencyInputComponent = ({
  step = 0.01,
  shouldFormat = true,
  prepend = '$',
  value,
  max = MAXIMUM_AMOUNT,
  error,
  onBlur,
  onChange,
  onValueChange,
  ...props
}: Props) => {
  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e)
    }

    if (onChange && value && !isNaN(parseFloat(value))) {
      onChange(shouldFormat ? formatCurrency(value) : value)
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (BLOCKED_NUMBER_CHARACTERS.includes(e.key)) {
      e.preventDefault()
    }
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!validateValue(e.target.value, step, max)) {
      return
    }

    if (onChange) {
      onChange(e)
    }
  }

  const handleValueChange = (v: string) => {
    if (!validateValue(v, step, max)) {
      return
    }

    if (onValueChange) {
      onValueChange(v)
    }
  }

  return (
    <Input
      value={value}
      error={error}
      type="number"
      prepend={prepend}
      hideSpinner
      step={step}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      onValueChange={handleValueChange}
      onBlur={handleBlur}
      {...props}
    />
  )
}

export const CurrencyInput = withFormikSupport(CurrencyInputComponent)
